import { useState } from 'react';

/**
 * Calls `reset` during render when any of `deps` changes (compared with `Object.is`), skipping the
 * first render. For local state that has to follow a prop, such as a draft copied from a saved
 * value or a form cleared when a modal opens.
 *
 * Unlike an effect this updates state before the render commits, so the stale value never paints.
 * `reset` may only set this component's own state.
 */
export function useResetOnChange(deps: readonly unknown[], reset: () => void): void {
  const [previous, setPrevious] = useState(deps);

  if (
    deps.length !== previous.length ||
    deps.some((dep, index) => !Object.is(dep, previous[index]))
  ) {
    setPrevious(deps);
    reset();
  }
}
